export const CALIFORNIA_STATE_CODE = "CA";
export const MINNESOTA_STATE_CODE = "MN";

// Regions (state or province) that should display the price with fees included.
// Use upper-case for the region codes.
export const REGIONS_WITH_INCLUDED_FEES = [
  CALIFORNIA_STATE_CODE,
  MINNESOTA_STATE_CODE
];

export const shouldIncludeFeesInThisRegion = (region: string) => {
  if (!region) {
    return false;
  }
  return REGIONS_WITH_INCLUDED_FEES.includes(region.toUpperCase());
};
